import { defineMessage } from 'services/localization';

export const messages = {
    total: defineMessage('total_2'),
    multicurrencyTotal: defineMessage('the_total_amount_is_app__derived_from_the_bills'),
    currencyTotal: defineMessage('final_total_amount_in_c_including_feeamount_fee'),
};
